<ef-loading [loading]="IsLoading"></ef-loading>

<div style="display: flex">
    <p-dialog header="Upload Excel File" [(visible)]="showUploadDialog" [maximizable]="false" [closable]="true"
        [closeOnEscape]="false" [style]="{ width: '35vw', height: '47vh' }">
        <div class="grid">
            <div class="col-12">
                <div class="grid">
                    <span class="col-12">
                        Steps for uploading a cumulative worksheet:
                    </span>
                    <span class="col-12">
                        1. Download the cumulative data entry worksheet
                    </span>
                    <span class="col-12">
                        2. Update the worksheet with cumulative figures in Excel
                    </span>
                    <span class="col-12">
                        3. Save the worksheet
                    </span>
                    <span class="col-12">
                        4. Upload the completed Excel worksheet on eFAACT Central - Contract Cumulatives process
                    </span>
                    <span class="col-12">
                        5. Once reviewed, commit the cumulatives to apply them
                    </span>
                </div>

            </div>
            <div class="col-12">
                <div class="grid flex">
                    <div class="col-12 justify-content-center text-center"
                        style="margin-top: 1em; padding: 2em; border: 2px dashed grey; background-color: #f0f0f0;">
                        <label for="file-upload" class="ef-file-upload">
                            <i class="pi pi-file-excel" style="color: black; padding-right: .25em;"></i>
                            Browse...
                        </label>
                        <span id="file-selected" style="padding-left: 1em"></span>
                        <input #fileUpload id="file-upload" type="file" accept=".xls, .xlsx"
                            (change)="uploadExcelFile($event)">

                        <p-message *ngIf="this.showUploadError" severity="error"
                            text="Please select a file first"></p-message>
                    </div>
                </div>
            </div>

        </div>






        <ng-template #footer >
            <button type="button" pButton icon="pi pi-upload" (click)="sendJSON()" label="Upload"
                class="p-button-text p-button-primary"></button>
            <button type="button" pButton (click)="this.showUploadDialog = false;" icon="pi pi-times" label="Cancel"
                class="p-button-text p-button-danger"></button>
        </ng-template>
    </p-dialog>
</div>

<div style="display: flex">
    <p-dialog header="Manually Add Cumulative(s)" [(visible)]="showManualAddDialog" [maximizable]="false"
        [closable]="true" [modal]="true" [closeOnEscape]="false" [style]="{ width: '25vw' }">
        <span class="p-text-secondary block mb-5">
            Build rows in cumulative entry grid with selected filters.
        </span>
        <form [formGroup]="buildFormGroup" #buildForm="ngForm" id="buildForm">
            <p-floatlabel variant="on" class="w-full mb-3 mt-2">
                <p-datepicker styleClass="w-full" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
                    appendTo="body" [showIcon]="true" inputId="aod" formControlName="Asofdate">
                </p-datepicker>
                <label for="aod">As of Date</label>
            </p-floatlabel>

            <div class="flex justify-content-center items-center gap-5 mb-3">
                <div class="p-field-radiobutton" style="padding-left: 0.5em">
                    <p-radioButton name="direct" value="direct" formControlName="direct" inputId="direct"></p-radioButton>
                    <label class="radio-label ml-2" for="direct">Direct</label>
                </div>
                <div class="p-field-radiobutton">
                    <p-radioButton name="indirect" value="indirect" formControlName="indirect"
                        inputId="indirect"></p-radioButton>
                    <label class="radio-label ml-2" for="indirect">Indirect</label>
                </div>
            </div>


            <p-floatlabel variant="on" class="w-full mb-3">
                <p-select styleClass="w-full" inputId="csel" [options]="contractsSelectItem" [filter]="true" appendTo="body"
                    [autoDisplayFirst]="false" formControlName="Contracts">
                </p-select>
                <label for="csel">Contract</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <p-multiSelect styleClass="w-full" inputId="tsel" maxSelectedLabels="1" appendTo="body"
                    [options]="tasksSelectItem" [filter]="true" formControlName="Tasks" maxSelectedLabels="1"
                    selectedItemsLabel="{0} items selected">
                </p-multiSelect>
                <label for="tsel">Task(s)</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <p-select styleClass="w-full" inputId="ttsel" [options]="txnTypesSelectItem" [filter]="true" appendTo="body"
                    [autoDisplayFirst]="false" formControlName="Txntypes">
                </p-select>
                <label for="ttsel">Txn Type</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <p-multiSelect styleClass="w-full" inputId="ccsel" appendTo="body" [options]="userGroupsSelectItem"
                    [filter]="true" formControlName="CC" maxSelectedLabels="1" selectedItemsLabel="{0} items selected">
                </p-multiSelect>
                <label for="ccsel">Cost Center(s)</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <p-multiSelect styleClass="w-full" inputId="sisel" [options]="serviceItemsSelectItem" [filter]="true"
                    appendTo="body" formControlName="ServiceItems" maxSelectedLabels="1"
                    selectedItemsLabel="{0} items selected">
                </p-multiSelect>
                <label for="sisel">Service Item(s)</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <p-multiSelect styleClass="w-full" inputId="esel" [options]="directReportsSelectItem" [filter]="true"
                    appendTo="body" formControlName="DirectReports" maxSelectedLabels="1"
                    selectedItemsLabel="{0} items selected">
                </p-multiSelect>
                <label for="esel">Employee(s)</label>
            </p-floatlabel>
        </form>

        <ng-template #footer>
            <button pRipple pButton label="Submit" title="Build rows in cumulative entry grid with selected filters"
                severity="success" text (click)="buildTable(); showManualAddDialog = false;"></button>
            <button pRipple pButton label="Clear" title="Clear values selected for Add" severity="danger" text
                (click)="clearBuild()"></button>
        </ng-template>
    </p-dialog>
</div>

<div class="card">
    <p-accordion [multiple]="true">
        <p-accordionTab header="Add cumulatives" [selected]="true">
            <p-toolbar>

                <!-- <div class="p-field-radiobutton" style="padding-left: 0.5em">
                    <p-radioButton name="worksheet" value="worksheet" formControlName="worksheet"
                        inputId="worksheet"></p-radioButton>
                    <label class="radio-label" for="worksheet">Load from Worksheet</label>
                </div>
                <div class="p-field-radiobutton">
                    <p-radioButton name="manual" value="manual" formControlName="manual"
                        inputId="manual"></p-radioButton>
                    <label class="radio-label" for="manual">Enter Manually</label>
                </div> -->

                <!-- <span class="p-float-label" *ngIf="fromWorksheet == false">
                    <p-datepicker [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030" appendTo="body"
                        [showIcon]="false" id="asofdate" formControlName="Asofdate">
                    </p-datepicker>
                    <label *ngIf="asOfDateIsRequired == true" style="color: red" for="float-dd">As of Date</label>
                    <label *ngIf="asOfDateIsRequired == false" for="float-dd">As of Date</label>
                </span>

                <div *ngIf="fromWorksheet == false" class="p-field-radiobutton" style="padding-left: 0.5em">
                    <p-radioButton name="direct" value="direct" formControlName="direct"
                        inputId="direct"></p-radioButton>
                    <label class="radio-label" for="direct">Direct</label>
                </div>
                <div *ngIf="fromWorksheet == false" class="p-field-radiobutton">
                    <p-radioButton name="indirect" value="indirect" formControlName="indirect"
                        inputId="indirect"></p-radioButton>
                    <label class="radio-label" for="indirect">Indirect</label>
                </div>

                <span *ngIf="fromWorksheet == false" class="p-float-label">
                    <p-dropdown [options]="contractsSelectItem" [filter]="true" appendTo="body"
                        [autoDisplayFirst]="false" formControlName="Contracts">
                    </p-dropdown>
                    <label *ngIf="contractIsRequired == true" style="color: red" for="float-dd">Contract</label>
                    <label *ngIf="contractIsRequired == false" for="float-dd">Contract</label>
                </span>

                <span *ngIf="fromWorksheet == false" class="p-float-label">
                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                        [options]="tasksSelectItem" [filter]="true" formControlName="Tasks" maxSelectedLabels="1"
                        selectedItemsLabel="{0} items selected">
                    </p-multiSelect>
                    <label *ngIf="taskIsRequired == true" style="color: red" for="float-dd">Task</label>
                    <label *ngIf="taskIsRequired == false" for="float-dd">Task</label>
                </span>

                <span *ngIf="fromWorksheet == false" class="p-float-label">
                    <p-dropdown [options]="txnTypesSelectItem" [filter]="true" appendTo="body"
                        [autoDisplayFirst]="false" formControlName="Txntypes">
                    </p-dropdown>
                    <label *ngIf="txnTypeIsRequired == true" style="color: red" for="float-dd">Txn Type</label>
                    <label *ngIf="txnTypeIsRequired == false" for="float-dd">Txn Type</label>
                </span>

                <span class="p-float-label" *ngIf="this.userGroups.length > 1 && fromWorksheet == false">
                    <p-multiSelect placeholder="Cost Center" appendTo="body" [options]="userGroupsSelectItem"
                        [filter]="true" formControlName="CC" maxSelectedLabels="1"
                        selectedItemsLabel="{0} items selected">
                    </p-multiSelect>
                    <label *ngIf="ccIsRequired == true" style="color: red" for="float-dd">Cost Center</label>
                    <label *ngIf="ccIsRequired == false" for="float-dd">Cost Center</label>
                </span>

                <span class="p-float-label" *ngIf="this.siHidden == false && fromWorksheet == false">
                    <p-multiSelect [options]="serviceItemsSelectItem" placeholder="Service Item" [filter]="true"
                        appendTo="body" formControlName="ServiceItems" maxSelectedLabels="1"
                        selectedItemsLabel="{0} items selected">
                    </p-multiSelect>
                    <label for="float-dd">Item</label>
                </span>

                <span class="p-float-label" *ngIf="this.empHidden == false && fromWorksheet == false">
                    <p-multiSelect [options]="directReportsSelectItem" placeholder="Employee" [filter]="true"
                        appendTo="body" formControlName="DirectReports" maxSelectedLabels="1"
                        selectedItemsLabel="{0} items selected">
                    </p-multiSelect>
                    <label for="float-dd">Person</label>
                </span>

                <button *ngIf="fromWorksheet == false" pRipple pButton label="Cumulatives" icon="pi pi-plus-circle"
                    title="Build rows in cumulative entry grid with selected filters" class="p-button-secondary"
                    (click)="buildTable()"></button>
                <button *ngIf="fromWorksheet == false" pRipple pButton label="Clear"
                    title="Clear values selected for Add" class="p-button-text" (click)="clearBuild()"></button> -->


                <button pButton pRipple icon="pi pi-hammer" label="Enter Manually"
                    title="Add cumulatives to the grid" severity="primary"
                    (click)="showManualAddDialog = true;"></button>

                <button pRipple pButton icon="pi pi-external-link" label="Build Worksheet" title="Build Worksheet"
                    severity="primary" (click)="openCumulativesReport()"></button>

                <button pRipple pButton icon="pi pi-upload" label="Upload Worksheet" title="Upload Worksheet"
                    severity="primary" (click)="openUploadDialog()"></button>

            </p-toolbar>
        </p-accordionTab>
        <p-accordionTab header="Contract Cumulatives" [selected]="true">
            <form [formGroup]="editFormGroup" #buildForm="ngForm" id="editForm">
                <p-toolbar>
                    <!-- Edit Mode -->
                    <div style="padding-right: 1vw">
                        <label style="
                                padding-right: 7px;
                                padding-left: 14px;
                                margin-bottom: 0px;
                                vertical-align: middle;
                            ">Edit Mode</label>
                        <p-checkbox [style]="{ 'vertical-align': 'middle' }" formControlName="EditMode" [binary]="true">
                        </p-checkbox>
                    </div>

                    <!-- Session Dates -->
                    <p-floatlabel variant="on">
                        <p-select inputId="sdsel" [options]="sessionDatesSelectItem" [filter]="true" appendTo="body"
                            [autoDisplayFirst]="true" formControlName="SessionDates" styleClass="w-14rem">
                        </p-select>
                        <label for="sdsel">Session Dates</label>
                    </p-floatlabel>
                    <!-- <span class="p-float-label">
                        <p-dropdown
                            placeholder="Session Dates"
                            [options]="sessionDatesSelectItem"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="true"
                            formControlName="SessionDates"
                        >
                        </p-dropdown>
                        <label
                            *ngIf="contractIsRequired == false"
                            for="float-dd"
                            >Session Dates</label
                        >
                    </span> -->

                    <button pRipple pButton [disabled]="this.editModeIsEnabled == true" icon="pi pi-check-square"
                        label="Commit Cumulatives" title="Commit cumulatives and rebuild contract summaries"
                        severity="primary" (click)="commitCumulatives()"></button>

                    <!-- <button
                        pRipple
                        pButton
                        icon="pi pi-external-link"
                        label="Build Worksheet"
                        title="Build Worksheet"
                        class="p-button-secondary"
                        (click)="openCumulativesReport()"
                    ></button>

                    <button
                        pRipple
                        pButton
                        icon="pi pi-upload"
                        label="Upload Worksheet"
                        title="Upload Worksheet"
                        class="p-button-secondary"
                        (click)="openUploadDialog()"
                    ></button> -->

                    <!-- <button pRipple pButton *ngIf="this.editModeIsEnabled == false" label="Show Today's Activity"
                        title="Show entries made today" class="p-button-text" (click)="showTodaysActivity()"></button>
                    <button pRipple pButton *ngIf="this.editModeIsEnabled == false" label="Show All"
                        title="Show all entered cumulatives" class="p-button-text" (click)="showAll()"></button>
                    <button pRipple pButton *ngIf="this.editModeIsEnabled == false" label="Hide Lines w/o $"
                        title="Hide lines that do not yet have $ entered in the grid" class="p-button-text"
                        (click)="clearLinesWithout$()"></button> -->
                    <div style="padding-left: 4em">
                        <div style="
                                justify-content: center;
                                display: flex;
                                border-bottom: 1px solid grey;
                            ">
                            <label style="margin: 0; font-size: 11px">ROW DISPLAY</label>
                        </div>
                        <button [disabled]="this.editModeIsEnabled == true" pButton pRipple type="button"
                            class="p-button-text" label="Today's Entries Only" (click)="showTodaysActivity()"></button>
                        <button [disabled]="this.editModeIsEnabled == true" pButton pRipple type="button"
                            class="p-button-text" label="All Entries" (click)="showAll()"></button>
                        <button [disabled]="this.editModeIsEnabled == true" pButton pRipple type="button"
                            class="p-button-text" label="All $$ Entries" (click)="clearLinesWithout$()"></button>
                    </div>

                    <div style="padding-left: 5em">
                        <div style="
                                justify-content: center;
                                display: flex;
                                border-bottom: 1px solid grey;
                            ">
                            <label style="margin: 0; font-size: 11px">COLUMN DISPLAY</label>
                        </div>
                        <button pButton pRipple type="button" class="p-button-text" label="Show/Hide Items"
                            (click)="showItems()"></button>
                        <button pButton pRipple type="button" class="p-button-text" label="Show/Hide Persons"
                            (click)="showPersons()"></button>
                    </div>
                </p-toolbar>
            </form>
            <div style="height: 40em">
                <div>
                    <p-table stripedRows #ContractCumTable id="ContractCumTable" [value]="this.tableItemSource" scrollHeight="48em"
                        [scrollable]="true" editMode="row" (onEditInit_Summary)="onEditInit($event)"
                        (onRowEditSave)="onRowEditSave($event)" dataKey="Txnid">
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="21" style="width: 100%" class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template #header>
                            <tr>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                    <i class="pi pi-exclamation-circle"></i>
                                </th>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
                                <th pFrozenColumn pSortableColumn="Cumstatus" [frozen]="IsColumnFrozen">
                                    Status
                                    <p-sortIcon field="Cumstatus" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <div *ngIf="IsFeatureLoading" style="
                                            justify-content: center;
                                            width: 100%;
                                    ">
                                        <p-progressSpinner styleClass="custom-spinner" [style]="{
                                                width: '1.7em',
                                                height: '1.7em'
                                            }" strokeWidth="8" fill="#C0C0C0" animationDuration=".8s">
                                        </p-progressSpinner>
                                    </div>
                                </th>
                                <th pFrozenColumn pSortableColumn="Txndate" [frozen]="IsColumnFrozen">
                                    Txn Date
                                    <p-sortIcon field="Txndate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <p-columnFilter type="text" matchMode="contains" field="Txndate" display="menu" class="ml-auto" />
                                    <!-- <p-columnFilter field="Txndate" matchMode="in" display="menu"
                                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                        class="ml-auto">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-datepicker [monthNavigator]="true"
                                                showButtonBar="true" [yearNavigator]="true" yearRange="2010:2030"
                                                appendTo="body" placeholder="Filter" [showIcon]="false" styleClass="w-full"
                                                [ngModel]="value"
                                                (ngModelChange)="filter($event)">
                                            </p-datepicker>
                                        </ng-template>
                                    </p-columnFilter> -->

                                </th>
                                <th pFrozenColumn pSortableColumn="TaskLongName" [frozen]="IsColumnFrozen">
                                    Task
                                    <p-sortIcon field="TaskLongName" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <p-columnFilter field="Tasklistid" matchMode="in" display="menu"
                                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                        class="ml-auto">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-multiSelect maxSelectedLabels="1" appendTo="body"
                                                [options]="this.tasksInTableSelectItem" [filter]="true"
                                                styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                        </ng-template>
                                    </p-columnFilter>
                                </th>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Txntype">
                                    Type
                                    <p-sortIcon field="Txntype" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <p-columnFilter field="Txntype" matchMode="in" display="menu"
                                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                        class="ml-auto">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                                [options]="txnTypesInTableSelectItem" [filter]="true"
                                                styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                        </ng-template>
                                    </p-columnFilter>
                                </th>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Costcenterid">
                                    Cost Center
                                    <p-sortIcon field="Costcenterid" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <p-columnFilter field="Costcenterid" matchMode="in" display="menu"
                                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                        class="ml-auto">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                                [options]="
                                                            userGroupsInTableSelectItem
                                                        " [filter]="true" styleClass="w-full" [ngModel]="value"
                                                (ngModelChange)="filter($event)">
                                            </p-multiSelect>

                                        </ng-template>
                                    </p-columnFilter>
                                </th>
                                <th *ngIf="SIColumnHidden == false" pSortableColumn="Silistid">
                                    Item
                                    <p-sortIcon field="Silistid" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <p-columnFilter field="Silistid" matchMode="in" display="menu"
                                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                        class="ml-auto">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                                [options]="
                                                            serviceItemsSelectItem
                                                        " [filter]="true" styleClass="w-full" [ngModel]="value"
                                                (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                        </ng-template>
                                    </p-columnFilter>
                                </th>
                                <th *ngIf="EmpColumnHidden == false" pSortableColumn="Employeelistid">
                                    Person
                                    <p-sortIcon field="Employeelistid" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <p-columnFilter field="Employeelistid" matchMode="in" display="menu"
                                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                        class="ml-auto">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                                [options]="
                                                            directReportsSelectItem
                                                        " [filter]="true" styleClass="w-full" [ngModel]="value"
                                                (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                        </ng-template>
                                    </p-columnFilter>
                                </th>
                                <th pSortableColumn="Hoursworked">
                                    Hours
                                    <p-sortIcon field="Hoursworked" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Invoiceamount">
                                    Invoice
                                    <p-sortIcon field="Invoiceamount" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Frcost">
                                    FR Invoice
                                    <p-sortIcon field="Frcost" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Ohcost">
                                    OH Invoice
                                    <p-sortIcon field="Ohcost" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Mhcost">
                                    MH Invoice
                                    <p-sortIcon field="Mhcost" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Gacost">
                                    GA Invoice
                                    <p-sortIcon field="Gacost" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Feecost">
                                    Fee Invoice
                                    <p-sortIcon field="Feecost" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Actualamount">
                                    Incurred
                                    <p-sortIcon field="Actualamount" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Frcostebr">
                                    FR Incurred
                                    <p-sortIcon field="Frcostebr" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Ohcostebr">
                                    OH Incurred
                                    <p-sortIcon field="Ohcostebr" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Mhcostebr">
                                    MH Incurred
                                    <p-sortIcon field="Mhcostebr" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Gacostebr">
                                    GA Incurred
                                    <p-sortIcon field="Gacostebr" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Feecostebr">
                                    Fee Incurred
                                    <p-sortIcon field="Feecostebr" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="Modifieddate">
                                    Modified
                                    <p-sortIcon field="Modifieddate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </th>
                                <th class="delete-cell"></th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-contractcum let-editing="editing" let-ri="rowIndex">
                            <tr [pEditableRow]="contractcum" data-id="row-{{ contractcum.Txnid }}">
                                <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                    <div style="height: 2em; align-self: center">
                                        <a (click)="
                                                ShowError.next(contractcum)
                                            ">
                                            <div>
                                                <ef-status-icon [status]="
                                                        contractcum?.Status
                                                            ?.StatusCode
                                                    " [message]="
                                                        contractcum?.Status
                                                            ?.Message
                                                    "></ef-status-icon>
                                            </div>
                                        </a>
                                    </div>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell">
                                    <button *ngIf="
                                            !editing &&
                                            (!editing?.Employeelistid ||
                                                !editing?.Employeelistid ===
                                                    contractcum?.Employeelistid) && this.editModeIsEnabled == true
                                        " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                        (click)="onRowEditInit(contractcum)" class="p-button-rounded p-button-text"
                                        title="Edit"></button>
                                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                        icon="pi pi-check" (click)="onRowEditSave(contractcum)"
                                        class="p-button-rounded p-button-text p-button-success" style="
                                            margin-right: 0.5em;
                                        "></button>
                                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                        icon="pi pi-times" (click)="onRowEditCancel(contractcum)"
                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen">
                                    <label [title]="contractcum.Cumstatus">{{
                                        contractcum.Cumstatus
                                        }}</label>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen">
                                    <label [title]="contractcum.Txndate">{{
                                        moment(contractcum.Txndate).format(
                                        'MM/DD/YYYY'
                                        )
                                        }}</label>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <p-select styleClass="w-full" [options]="this.tasksInTableSelectItem" [filter]="true" appendTo="body"
                                                [autoDisplayFirst]="false" [(ngModel)]="contractcum.TaskName">
                                            </p-select>
                                            <!-- <div *ngIf="this.tasksInTableSelectItem as items">                                               
                                                <ef-dropdown [items]="items" [rowData]="contractcum"
                                                    property="Tasklistid"></ef-dropdown>
                                            </div> -->
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <div [title]="
                                                    this.findTask(contractcum)
                                                " *ngIf="
                                                    contractcum.Tasklistid !=
                                                    null
                                                ">
                                                {{ this.findTask(contractcum) }}
                                            </div>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <p-select styleClass="w-full" [options]="this.txnTypesInTableSelectItem" [filter]="true" appendTo="body"
                                                [autoDisplayFirst]="false" [(ngModel)]="contractcum.Txntype">
                                            </p-select>
                                            <!-- <div *ngIf="
                                                    txnTypesInTableSelectItem as items
                                                ">
                                                <ef-dropdown [items]="items" [rowData]="contractcum"
                                                    property="Txntype"></ef-dropdown>
                                            </div> -->
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <div *ngIf="
                                                    contractcum.Txntype != null
                                                ">
                                                {{
                                                this.findTxnType(
                                                contractcum.Txntype
                                                )
                                                }}
                                            </div>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <p-select styleClass="w-full" [options]="this.userGroupsInTableSelectItem" [filter]="true" appendTo="body"
                                                [autoDisplayFirst]="false" [(ngModel)]="contractcum.Costcenterid">
                                            </p-select>
                                            <!-- <div *ngIf="
                                                    userGroupsInTableSelectItem as items
                                                ">
                                                <ef-dropdown [items]="items" [rowData]="contractcum"
                                                    property="Costcenterid"></ef-dropdown>
                                            </div> -->
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <div *ngIf="
                                                    contractcum.Costcenterid !=
                                                    null
                                                ">
                                                {{
                                                this.findCostCenterName(
                                                contractcum.Costcenterid
                                                )
                                                }}
                                            </div>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="SIColumnHidden == false">
                                    <div *ngIf="this.siColumnHidden == false">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-select styleClass="w-full" [options]="this.serviceItemsSelectItem" [filter]="true" appendTo="body"
                                                    [autoDisplayFirst]="false" [(ngModel)]="contractcum.Silistid">
                                                </p-select>
                                                <!-- <div *ngIf="
                                                        serviceItemsSelectItem as items
                                                    ">
                                                    <ef-dropdown [items]="items" [rowData]="contractcum"
                                                        property="Silistid"></ef-dropdown>
                                                </div> -->
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <div [title]="
                                                        this.findServiceItem(
                                                            contractcum
                                                        )
                                                    " *ngIf="
                                                        contractcum.Silistid !=
                                                        null
                                                    ">
                                                    {{
                                                    this.findServiceItem(
                                                    contractcum
                                                    )
                                                    }}
                                                </div>
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                </td>
                                <td *ngIf="EmpColumnHidden == false">
                                    <div *ngIf="this.empColumnHidden == false">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-select styleClass="w-full" [options]="this.directReportsSelectItem" [filter]="true" appendTo="body"
                                                    [autoDisplayFirst]="false" [(ngModel)]="contractcum.Employeelistid">
                                                </p-select>
                                                <!-- <div *ngIf="
                                                        directReportsSelectItem as items
                                                    ">
                                                    <ef-dropdown [items]="items" [rowData]="contractcum"
                                                        property="Employeelistid"></ef-dropdown>
                                                </div> -->
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <div [title]="
                                                        this.findEmployee(
                                                            contractcum
                                                        )
                                                    " *ngIf="
                                                        contractcum.Employeelistid !=
                                                        null
                                                    ">
                                                    {{
                                                    this.findEmployee(
                                                    contractcum
                                                    )
                                                    }}
                                                </div>
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="
                                                    contractcum.Hoursworked
                                                " />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Hoursworked }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="
                                                    contractcum.Invoiceamount
                                                " />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Invoiceamount }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="contractcum.Frcost" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Frcost }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="contractcum.Ohcost" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Ohcost }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="contractcum.Mhcost" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Mhcost }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="contractcum.Gacost" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Gacost }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="
                                                    contractcum.Feecost
                                                " />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Feecost }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="
                                                    contractcum.Actualamount
                                                " />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Actualamount }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="
                                                    contractcum.Frcostebr
                                                " />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Frcostebr }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="
                                                    contractcum.Ohcostebr
                                                " />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Ohcostebr }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="
                                                    contractcum.Mhcostebr
                                                " />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Mhcostebr }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="
                                                    contractcum.Gacostebr
                                                " />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Gacostebr }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [(ngModel)]="
                                                    contractcum.Feecostebr
                                                " />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ contractcum.Feecostebr }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <div *ngIf="contractcum.Modifieddate">
                                        <label [title]="contractcum.Modifieddate">{{
                                            moment(
                                            contractcum.Modifieddate
                                            ).format('MM/DD/YYYY')
                                            }}</label>
                                    </div>
                                </td>
                                <td class="delete-cell">
                                    <button *ngIf="this.editModeIsEnabled == true" pButton type="button"
                                        icon="pi pi-trash" class="p-button-danger p-button-rounded p-button-text"
                                        (click)="
                                            onContractCumDelete(contractcum)
                                        "></button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
